import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface PortalGuruModalAutoClosedInfoProps {
    shiftName: string;
    onClose: () => void;
}

export const PortalGuruModalAutoClosedInfo: React.FC<PortalGuruModalAutoClosedInfoProps> = ({ shiftName, onClose }) => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className="absolute top-4 right-4">
                    <button onClick={onClose} className="p-1 rounded-full text-gray-500 hover:bg-gray-100 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <div className="mx-auto w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mb-5 ring-8 ring-amber-50">
                    <AlertCircle size={40} className="text-amber-600" />
                </div>

                <h3 className="text-lg font-bold text-gray-900 tracking-tight mb-2">Informasi Presensi</h3>
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                    Afwan, pada sesi <span className="font-semibold text-gray-800">{shiftName || 'sebelumnya'}</span> Anda tidak melakukan presensi pulang. Sesi telah ditutup otomatis oleh sistem.
                </p>

                <button
                    onClick={onClose}
                    className="w-full py-3.5 bg-[#40513B] hover:bg-[#344230] text-white font-bold rounded-xl shadow-lg shadow-[#40513B]/25 transition-all active:scale-[0.98]"
                >
                    Mengerti
                </button>
            </div>
        </div>
    );
};
